package pl.decks.personal.theme

import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color

@InitSilk
fun updateTheme(context: InitSilkContext) {
    with(context.theme.palettes) {
        light.apply {
            background = SiteColors.Light
            this.color = SiteColors.Dark
            border = SiteColors.DarkerLight
        }
        dark.apply {
            background = SiteColors.Dark
            this.color = SiteColors.Light
            border = SiteColors.LighterDark
        }
    }
}
